import {
  MotifChip,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { dateFunc } from "@/components/Functions/dateFunc";
import { useSelector } from "react-redux";

export const useReportingHeaderConst = (
  documnetId: any,
  reportId: any,
  reportType: any
) => {
  const { t } = useTranslation();
  const { caseShortName, abbreviation } = useSelector(
    (state: any) => state.case
  );
  const statusData: any = {
    0: "Completed",
    1: "In queue",
    2: "In Progress",
    3: "Failed",
  };
  const statusDataColorCode: any = {
    0: "success",
    1: "monochrome-light",
    2: "monochrome-dark",
    3: "error",
  };
  const statusMessages: any = {
    0: "Ready to download",
    1: "Document is being generated",
    2: "Document is being generated",
    3: "Failed",
  };
  return reportId === "1"
    ? [
        {
          cellRenderer:(params:any)=>{
            return <>{[1,2].includes(params.data.processingStatus)?`${caseShortName}_${t("pages.reporting.reportListLabels.paymentRegister")}`:params.data.documentName}</>;
          },
          field: "documentName",
          headerName: t("pages.reporting.columnDetails.column1"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 220,
          type: "documentNameType",
        },

        {
          cellRenderer: (params: any) => {
            return <><MotifChip variant={statusDataColorCode[params.data.processingStatus]} >{statusData?.[params.data.processingStatus]}</MotifChip> </>;
          },
          field: "processingStatus",
          type: "processingStatusType",
          headerName: t("pages.reporting.columnDetails.column5"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 125,
        },
        {
          cellRenderer: (params: any) => {
            return (
              <>
                {params.data.processingStatus === 3
                  ? params.data.statusMessage
                  : statusMessages?.[params.data.processingStatus]}
              </>
            );
          },
          field: "statusMessage",
          type: "statusMessageType",
          headerName: t("pages.reporting.columnDetails.column6"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 220,
          wrapText: true,
          autoHeight: true,
        },
        {
          cellRenderer: "createdByCellRenderer",
          field: "createdBy",
          type: "createdByType",
          headerName: "CreatedBy",
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 180,
        },
        {
          cellRenderer: (params: any) => {
            return (
              <>{`${
                dateFunc(params.data.createdOn).formattedDateTime
              } ${abbreviation}`}</>
            );
          },
          field: "createdOn",
          type: "createdOnType",
          headerName: t("pages.reporting.columnDetails.column4"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 220,
        },
        {
          cellRenderer: "paymentRegisterDownload",
          field: "",
          headerName: "",
          sortable: false,
          unSortIcon: true,
          flex: 1,
          minWidth: 70,
          cellRendererParams: {
            selectedDoumnetId: documnetId || "",
            caseAbbrevation: abbreviation,
            caseShortName: caseShortName,
            reportType: reportType,
          },
          cellStyle: {
            cursor: "pointer",
          },
        },
      ]
    : reportId === "2"
    ? [
        {
          cellRenderer: "documentNameCellRenderer",
          field: "documentName",
          type: "documentNameType",
          headerName: t("pages.reporting.columnDetails.column1"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
        },
        {
          cellRenderer: "createdByCellRenderer",
          field: "comment",
          type: "commentType",
          headerName: t("pages.reporting.columnDetails.column2"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
          headerClass: "stepHeaderClass",
          cellClass: "align-right",
        },
        {
          cellRenderer: "createdOnCellRenderer",
          field: "createdBy",
          type: "createdByType",
          headerName: t("pages.reporting.columnDetails.column3"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
        },
        {
          cellRenderer: (params: any) => (
            <>{`${dateFunc(params.data.createdOn).formattedDateTime} ${
              params.data.abbreviation
            }`}</>
          ),

          field: "createdOn",
          type: "createdOnType",
          headerName: t("pages.reporting.columnDetails.column4"),
          sortable: true,
          unSortIcon: true,
          flex: 1,
        },
        {
        
          cellRenderer: "payeeMatchReportDownload",
          cellRendererParams: {
            selectedDoumnetId: documnetId || "",
            caseAbbrevation: abbreviation,
            caseShortName: caseShortName,
            reportType: reportType,
          },
          field: "",
          headerName: "",
          flex: 0.4,
          minWidth: 50,
          sortable: false,
          cellClass: "align-right",
          unSortIcon: true,
          cellStyle: {
            cursor: "pointer",
          },
        },
      ]
    : [];
};
